module.exports = __webpack_public_path__ + "img/p3i1_en.ca265cb9.png";